import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input, OnInit } from '@angular/core';
import { filter, takeUntil } from 'rxjs';

import { IRotation360Config, SdRotation360Component } from '@seb/web-design-system/rotation-360';
import { IMedia, SdSpyTargetDirective } from '@seb/web-design-system/core';

import { Rotating360WrapperComponentInterface } from '../../../models';
import { AbstractComponent } from '../abstract-component.component';
import { ComponentService, ImageService } from '../../../services';
import { WrapperComponent } from '../../../components/static/core';

@Component({
  selector: 'wc-rotating-360-wrapper',
  templateUrl: './rotating-360-wrapper.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    WrapperComponent,
    SdRotation360Component,
    SdSpyTargetDirective
  ]
})
export class Rotating360WrapperComponent extends AbstractComponent<Rotating360WrapperComponentInterface> implements OnInit {
  @Input() class = '';

  @HostBinding('class')
  get hostClasses(): string {
    return [this.class, 'wc-component is-cms'].filter(Boolean).join(' ');
  }

  medias: IRotation360Config;
  autoplay: boolean;

  constructor(
    private componentService: ComponentService,
    private imageService: ImageService,
    private cdRef: ChangeDetectorRef
  ) {
    super();
  }

  static areMandatoryFilled(cmp: Rotating360WrapperComponentInterface): boolean {
    return !!cmp.medias && !!cmp.width && !!cmp.height;
  }

  ngOnInit(): void {
    this.component$
      .pipe(
        this.componentService.reloadComponentForArrayProperties(['medias']),
        filter((cmp) => Rotating360WrapperComponent.areMandatoryFilled(cmp)),
        takeUntil(this.destroy$)
      )
      .subscribe((cmp: Rotating360WrapperComponentInterface) => {
        const mediaList: IMedia[] = Object.values(cmp.medias).map((image) => this.imageService.normalizeMedia(image));
        this.autoplay = cmp.autoplay;
        this.medias = {
          images: mediaList.length === 1 ? mediaList[0].url : mediaList.map((image) => image.url),
          count: Number(cmp.count),
          perRow: Number(cmp.perRow),
          width: Number(cmp.width),
          height: Number(cmp.height),
          swipeTarget: undefined
        };
        this.setLoaded();
        this.cdRef.markForCheck();
      });
  }
}
